import React, { useState } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Select from 'react-select';
import HeaderTitle from './HeaderTitle';
import Container from './HeaderContainer';
import { app } from '../../redux/actions';
import EventTracker from '../../helpers';

const Content = styled.div`
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1.5fr .75fr;
  padding: 0px 20px;
`;

const Header = ({
  setDistrictId, setLocality, districts
}) => {
  const [selectedOption, setSelectedOption] = useState(null);

  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);

    const { value } = selectedOption;
    const [district_id, cms_locality_id] = value.split('-');

    setDistrictId(district_id);
    setLocality(cms_locality_id);

    EventTracker('Plugin Visit');
  };

  const options = districts.map((item) => ({
    value: `${item.district_id}-${item.cms_locality_id}`,
    label: item.district_nm
  }));

  const customStyles = {
    option: (provided) => ({
      ...provided,
      height: '40px !important',
      fontSize: '12px !important',
      fontWeight: 'normal !important',
      alignSelf: 'center !important',
      textAlign: 'left !important',
      textOverflow: 'ellipsis !important',
      whiteSpace: 'nowrap !important',
      display: 'inline-block !important',
    }),
    control: (provided) => ({
      ...provided,
      position: 'relative !important',
      boxSizing: 'border-box !importan',
      height: '40px !important',
      marginTop: '13px !important',
      fontSize: '12px !important',
      fontWeight: 'normal !important',
      alignSelf: 'center !important',
      textAlign: 'left !important',
      textOverflow: 'ellipsis !important',
      whiteSpace: 'nowrap !important',
    }),
    menu: (provided) => ({
      ...provided,
      marginTop: '-10px !important'
    })
  };

  return (
    <Container>
      <Content>
        <HeaderTitle
          align="left"
          title="Recycle Coach at Work"
        />
        {
          districts
          && districts.length
          && (districts.length > 1) ? (
            <Select
              tabIndex="0"
              value={selectedOption}
              onChange={handleChange}
              placeholder="Select the District"
              styles={customStyles}
              options={options}
            />
            ) : (
              null
            )
        }
      </Content>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  districts: state.app.districts,
});

const mapDispatchToProps = (dispatch) => ({
  setLocality: (val) => dispatch(app.setLocality(val)),
  setDistrictId: (val) => dispatch(app.setDistrictId(val))
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
